import * as React from 'react';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { formatoDecimal } from '../../../../utilities/formatoNumeros';
import { puedeConfirmarNovedad } from '../../../../utilities/Novedades/extractNovedadesResultadosRawList';
import { toast } from '../../../../utilities/appToast';
import '../../Liquidaciones/Components/LiquidacionDetalleTabla.css';
import '../../Liquidaciones/Components/GestionLiquidaciones.css';
import './NovedadesListItems.css';

const validateImporteInput = (text) => {
  if (text === "") return true;
  return /^[0-9]+([.,][0-9]{0,2})?$/.test(String(text).trim());
};

export default class NovedadesList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      liquidaciones: props.liquidaciones,
      seleccionarTodo: false,
      nuevoImporte: null,
      openEditPopoverId: null
    }
  };

  componentDidUpdate(prevProps) {
    if (prevProps.liquidaciones !== this.props.liquidaciones) {
      this.setState({ liquidaciones: this.props.liquidaciones })
    }
  }

  handleChangeCheckbox = (id) => {
    this.setState((prevState) => {
      const liquidaciones = prevState.liquidaciones.map((liquidacion) => {
        if (liquidacion.idNovedad === id) {
          return {
            ...liquidacion,
            checked: !liquidacion.checked
          };
        }
        return liquidacion;
      });
      return { liquidaciones };
    });
  };

  handleSelectAllCheckbox(seleccionarTodo) {
    this.setState((prevState) => {
      const liquidaciones = prevState.liquidaciones.map((liquidacion) => ({
        ...liquidacion,
        checked: seleccionarTodo
      }));
      return { liquidaciones };
    });
    this.setState({ seleccionarTodo: seleccionarTodo });
  };

  onChangeImporte = (event) => {

    const { value } = event.target;

    if (validateImporteInput(value)) {
      this.setState({ nuevoImporte: value });
    };
  }

  loadEditInputs = (liquidacion) => {
    this.setState({
      nuevoImporte: liquidacion.importe,
      openEditPopoverId: liquidacion.idNovedad
    });
  }

  closeEditPopover = () => {
    this.setState({
      openEditPopoverId: null,
      nuevoImporte: null
    });
  }

  confirmarNovedades() {

    let idLiquidaciones = this.state.liquidaciones
                          .filter(x => x.checked === true && puedeConfirmarNovedad(x))
                          .map(x => x.idNovedad)
    ;

    if (idLiquidaciones.length === 0) {
      toast.warn("Selecione alguna novedad");
      return;
    }

    this.setState({ seleccionarTodo: false });
    this.props.confirmarNovedadesFunction(idLiquidaciones);
  };

  editarNovedad(idNovedad) {

    if (this.state.nuevoImporte === null) {
      toast.warn("Ingrese un importe válido");
      return;
    };

    const importeNormalizado = String(this.state.nuevoImporte).trim().replace(",", ".");
    if (importeNormalizado === "" || Number.isNaN(Number.parseFloat(importeNormalizado))) {
      toast.warn("Ingrese un importe válido");
      return;
    }

    this.props.editarNovedadFunction(idNovedad, Number.parseFloat(importeNormalizado));
    this.closeEditPopover();
  };


  render = () => {

    const { openEditPopoverId } = this.state;

    const total = this.state.liquidaciones.length;

    return (
      <div className="gestion-liquidaciones-resultados liquidacion-detalle-seccion novedades-list">
        <div className="liquidacion-detalle-tabla-card">
          <div className="liquidacion-detalle-tabla-card__header flex-wrap">
            <div className="d-flex flex-wrap align-items-center gap-2 gap-md-3">
              <h5 className="liquidacion-detalle-tabla-card__title mb-0">Resultados</h5>
              <span className="liquidacion-detalle-tabla-card__badge">
                {total} novedad{total !== 1 ? 'es' : ''}
              </span>
              <label className="d-inline-flex align-items-center gap-2 mb-0 small text-muted">
                <input
                  type="checkbox"
                  className="form-check-input big-checkbox m-0"
                  checked={this.state.seleccionarTodo}
                  onChange={() => this.handleSelectAllCheckbox(!this.state.seleccionarTodo)}
                />
                Seleccionar todo
              </label>
              <button
                type="button"
                title="Confirmar Novedades"
                className="btn btn-sm gestion-liquidaciones-btn-guardar"
                onClick={() => this.confirmarNovedades()}
              >
                Marcar confirmadas
              </button>
            </div>
            {this.props.onOrdenFechaChange && (
              <div className="d-flex flex-wrap align-items-center gap-2">
                <label className="small text-muted mb-0" htmlFor="novedades-orden-fecha">Orden por fecha</label>
                <select
                  id="novedades-orden-fecha"
                  className="form-select form-select-sm w-auto"
                  value={this.props.ordenFecha ?? "desc"}
                  onChange={(e) => this.props.onOrdenFechaChange(e.target.value)}
                >
                  <option value="desc">Más recientes primero</option>
                  <option value="asc">Más antiguas primero</option>
                </select>
              </div>
            )}
          </div>

          <div className="liquidacion-detalle-tabla-card__body">
            <div className="novedades-list__table-wrap">
              <table className="table table-hover liquidacion-detalle-tabla novedades-list__table mb-0">
                <thead>
                  <tr>
                    <th className="novedades-list__th-check" aria-label="Selección" />
                    <th>Fecha</th>
                    <th>Seller</th>
                    <th>Orden Ref.</th>
                    <th>Concepto</th>
                    <th>Acción</th>
                    <th>Importe</th>
                    <th>% Penal.</th>
                    <th>Estado</th>
                    <th>Editar</th>
                  </tr>
                </thead>
                <tbody>
                {
                  this.state.liquidaciones.map((liquidacion, i) => {
                    return (
                      <tr key={liquidacion.idNovedad ?? i}>
                        <td className="novedades-list__td-check">
                          <input
                            type="checkbox"
                            className="big-checkbox"
                            hidden={!puedeConfirmarNovedad(liquidacion)}
                            checked={liquidacion.checked || false}
                            onChange={() => this.handleChangeCheckbox(liquidacion.idNovedad)}
                          />
                        </td>
                        <td>{liquidacion.fechaNovedad ? liquidacion.fechaNovedad : "No disponible"}</td>
                        <td>{liquidacion.sellerRazonSocial}</td>
                        <td>{liquidacion.ordenDeReferencia}</td>
                        <td>
                          <div className="novedades-list__concepto">
                            <span>{liquidacion.detalleTipoNovedad}</span>
                            <span className="novedades-list__comentario">
                              {liquidacion.comentarios == "" ? "-" : liquidacion.comentarios}
                            </span>
                          </div>
                        </td>
                        <td>{liquidacion.detalleSubTipoNovedad}</td>
                        <td>${formatoDecimal(liquidacion.importe)}</td>
                        <td>
                          {(() => {
                            const valor = liquidacion.porcentajePenalidad ?? liquidacion.porcentaje ?? liquidacion.PorcentajePenalidad ?? liquidacion.Porcentaje;
                            if (valor == null || valor === "") return "—";
                            const num = Number(valor);
                            return Number.isFinite(num) ? `${num}%` : "—";
                          })()}
                        </td>
                        <td>{liquidacion.detalleEstadoNovedad}</td>
                        <td>
                          <div className="d-inline-flex align-items-center gap-1 flex-wrap">
                            <OverlayTrigger
                              key={`overlay-edit-${i}`}
                              trigger="click"
                              rootClose={true}
                              show={openEditPopoverId === liquidacion.idNovedad}
                              onToggle={(nextShow) => {
                                if (nextShow) {
                                  this.loadEditInputs(liquidacion);
                                } else if (openEditPopoverId === liquidacion.idNovedad) {
                                  this.closeEditPopover();
                                }
                              }}
                              placement={"left"}
                              containerPadding={16}
                              popperConfig={{
                                modifiers: [
                                  {
                                    name: 'offset',
                                    options: {
                                      offset: [0, 10]
                                    }
                                  },
                                  {
                                    name: 'flip',
                                    options: {
                                      fallbackPlacements: ['bottom', 'top']
                                    }
                                  },
                                  {
                                    name: 'preventOverflow',
                                    options: {
                                      boundary: 'viewport',
                                      padding: 16
                                    }
                                  }
                                ]
                              }}
                              overlay={
                                <Popover id={`popover-edit-${i}`} style={{ minWidth: '280px', maxWidth: '320px' }}>
                                  <Popover.Header className="fw-bold bg-light border-bottom" as="h3">Actualizar importe</Popover.Header>
                                  <Popover.Body>
                                    <div className="d-flex flex-column gap-3">
                                      <div>
                                        <label className="form-label small text-muted mb-1">Nuevo importe</label>
                                      <input
                                        type="text"
                                        className="form-control form-control-sm"
                                        value={this.state.nuevoImporte}
                                        onChange={this.onChangeImporte}
                                        maxLength="10"
                                        inputMode="decimal"
                                        autoComplete="off"
                                      />
                                      </div>

                                      <div className="d-flex justify-content-end gap-2">
                                        <button
                                          type="button"
                                          className="btn btn-sm gestion-liquidaciones-btn-limpiar"
                                          onClick={this.closeEditPopover}
                                        >
                                          Cancelar
                                        </button>

                                        <button
                                          type="button"
                                          onClick={() => this.editarNovedad(liquidacion.idNovedad)}
                                          className="btn btn-sm gestion-liquidaciones-btn-guardar"
                                          disabled={
                                            this.state.nuevoImporte === liquidacion.importe ||
                                            this.state.nuevoImporte === ""
                                          }
                                        >
                                          Actualizar
                                        </button>
                                      </div>
                                    </div>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <button
                                type="button"
                                title="Actualizar Importe"
                                className={`btn btn-sm ${openEditPopoverId === liquidacion.idNovedad ? 'gestion-liquidaciones-btn-guardar' : 'gestion-liquidaciones-btn-limpiar'}`}
                              >
                                <i className="fa fa-clipboard" aria-hidden="true"/>
                              </button>
                            </OverlayTrigger>

                            <OverlayTrigger
                              key={`overlay-delete-${i}`}
                              trigger="click"
                              rootClose={true}
                              placement={"left"}
                              containerPadding={16}
                              popperConfig={{
                                modifiers: [
                                  {
                                    name: 'offset',
                                    options: {
                                      offset: [0, 8]
                                    }
                                  },
                                  {
                                    name: 'flip',
                                    options: {
                                      fallbackPlacements: ['bottom', 'top']
                                    }
                                  },
                                  {
                                    name: 'preventOverflow',
                                    options: {
                                      boundary: 'viewport',
                                      padding: 16
                                    }
                                  }
                                ]
                              }}
                              overlay={
                                <Popover id={`popover-delete-${i}`}>
                                  <Popover.Header as="h3">¿Eliminar Novedad?</Popover.Header>
                                  <Popover.Body className="row justify-content-center">
                                    <button
                                      className="btn btn-sm gestion-liquidaciones-btn-guardar col-auto"
                                      onClick={() => this.props.eliminarNovedadFunction(liquidacion.idNovedad)}
                                    >
                                      Eliminar
                                    </button>
                                  </Popover.Body>
                                </Popover>
                              }
                            >
                              <button
                                title="Eliminar"
                                type="button"
                                className="btn btn-sm color-rojo-megatone"
                              >
                                <i className="fa fa-trash" aria-hidden="true"/>
                              </button>
                            </OverlayTrigger>
                          </div>
                        </td>
                      </tr>
                    )
                  })
                }
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
